export interface GalleryImage {
  id: number;
  src: string;
  alt: string;
  span?: 'wide' | 'tall' | 'normal';
}

export interface GallerySection {
  id: string;
  title: string;
  subtitle: string;
  labelKey: string;
  subtitleKey: string;
  icon: string;
  images: GalleryImage[];
}

export const gallerySections: GallerySection[] = [
  {
    id: 'burgers',
    title: 'Signature Burgers',
    subtitle: 'Gourmet Colombian burgers crafted with bold flavors and premium ingredients',
    labelKey: 'gallery_cat_burgers',
    subtitleKey: 'gallery_cat_burgers_sub',
    icon: 'ri-restaurant-line',
    images: [
      {
        id: 101,
        src: 'https://readdy.ai/api/search-image?query=Massive%20gourmet%20Colombian%20burger%20towering%20with%20melted%20cheddar%20cheese%20caramelized%20onions%20fresh%20lettuce%20tomato%20secret%20sauce%20brioche%20bun%20dark%20moody%20dramatic%20food%20photography%20professional%20studio%20black%20background%20orange%20accent%20lighting%20cinematic%20close%20up%20hero%20shot%20premium%20quality&width=800&height=600&seq=gb1&orientation=landscape',
        alt: 'Bucara Classic Burger – Colombian gourmet burger Boise Idaho',
        span: 'wide',
      },
      {
        id: 102,
        src: 'https://readdy.ai/api/search-image?query=Double%20smash%20burger%20two%20beef%20patties%20melted%20cheese%20crispy%20bacon%20jalapenos%20Colombian%20pink%20sauce%20stacked%20high%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20premium%20gourmet&width=500&height=600&seq=gb2&orientation=portrait',
        alt: 'Doble Colombiana smash burger',
        span: 'tall',
      },
      {
        id: 103,
        src: 'https://readdy.ai/api/search-image?query=Crispy%20fried%20chicken%20burger%20coleslaw%20avocado%20pickled%20onions%20chipotle%20mayo%20sesame%20bun%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20gourmet%20Latin%20style%20premium&width=500&height=500&seq=gb3&orientation=squarish',
        alt: 'Pollo Paisa crispy chicken burger',
        span: 'normal',
      },
      {
        id: 104,
        src: 'https://readdy.ai/api/search-image?query=BBQ%20glazed%20burger%20smoky%20beef%20patty%20crispy%20onion%20rings%20bacon%20cheddar%20pickles%20toasted%20brioche%20bun%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20gourmet%20premium&width=500&height=500&seq=gb4&orientation=squarish',
        alt: 'Bucara BBQ Burger with smoky glaze',
        span: 'normal',
      },
      {
        id: 105,
        src: 'https://readdy.ai/api/search-image?query=Burger%20cross%20section%20cut%20in%20half%20showing%20juicy%20beef%20patty%20layers%20melted%20cheese%20toppings%20brioche%20bun%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20premium%20gourmet%20detail%20shot&width=800&height=500&seq=gb5&orientation=landscape',
        alt: 'Burger cross section showing layers',
        span: 'wide',
      },
      {
        id: 106,
        src: 'https://readdy.ai/api/search-image?query=Mushroom%20Swiss%20burger%20sauteed%20mushrooms%20Swiss%20cheese%20garlic%20aioli%20arugula%20pretzel%20bun%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20gourmet%20premium&width=500&height=500&seq=gb6&orientation=squarish',
        alt: 'Mushroom Swiss gourmet burger',
        span: 'normal',
      },
    ],
  },
  {
    id: 'hotdogs',
    title: 'Colombian Hot Dogs',
    subtitle: 'Authentic perros colombianos loaded with bold toppings and signature sauces',
    labelKey: 'gallery_cat_hotdogs',
    subtitleKey: 'gallery_cat_hotdogs_sub',
    icon: 'ri-fire-line',
    images: [
      {
        id: 201,
        src: 'https://readdy.ai/api/search-image?query=Colombian%20perro%20caliente%20hot%20dog%20loaded%20with%20crushed%20chips%20pineapple%20sauce%20pink%20sauce%20mustard%20ketchup%20queso%20costeno%20colorful%20toppings%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20authentic%20street%20food&width=800&height=550&seq=hd1&orientation=landscape',
        alt: 'Perro Colombiano Clásico loaded hot dog',
        span: 'wide',
      },
      {
        id: 202,
        src: 'https://readdy.ai/api/search-image?query=Jumbo%20Colombian%20hot%20dog%20bacon%20strips%20caramelized%20onions%20jalapeno%20relish%20signature%20sauces%20mountain%20toppings%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20street%20food%20gourmet%20premium&width=500&height=600&seq=hd2&orientation=portrait',
        alt: 'Perro Especial Bucara jumbo hot dog',
        span: 'tall',
      },
      {
        id: 203,
        src: 'https://readdy.ai/api/search-image?query=Tropical%20hot%20dog%20mango%20salsa%20coconut%20cream%20toasted%20coconut%20flakes%20lime%20Colombian%20twist%20colorful%20toppings%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20street%20food&width=500&height=500&seq=hd3&orientation=squarish',
        alt: 'Perro Tropical with mango salsa',
        span: 'normal',
      },
      {
        id: 204,
        src: 'https://readdy.ai/api/search-image?query=Spicy%20Colombian%20hot%20dog%20jalapenos%20habanero%20sauce%20crispy%20shallots%20sriracha%20mayo%20crushed%20tortilla%20chips%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20street%20food%20spicy&width=500&height=500&seq=hd4&orientation=squarish',
        alt: 'Perro Picante spicy hot dog',
        span: 'normal',
      },
      {
        id: 205,
        src: 'https://readdy.ai/api/search-image?query=Colombian%20hot%20dog%20preparation%20overhead%20flat%20lay%20all%20toppings%20arranged%20sauces%20chips%20cheese%20colorful%20ingredients%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20overhead%20shot%20street%20food&width=800&height=500&seq=hd5&orientation=landscape',
        alt: 'Colombian hot dog toppings flat lay',
        span: 'wide',
      },
    ],
  },
  {
    id: 'fastfood',
    title: 'Latin Fast Food',
    subtitle: 'Empanadas, arepas, patacones, and Colombian street food favorites',
    labelKey: 'gallery_cat_fastfood',
    subtitleKey: 'gallery_cat_fastfood_sub',
    icon: 'ri-bowl-line',
    images: [
      {
        id: 301,
        src: 'https://readdy.ai/api/search-image?query=Colombian%20empanadas%20golden%20crispy%20fried%20wheat%20yuca%20stuffed%20beef%20chicken%20cheese%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20street%20food%20authentic%20traditional&width=800&height=550&seq=lf1&orientation=landscape',
        alt: 'Colombian empanadas golden and crispy',
        span: 'wide',
      },
      {
        id: 302,
        src: 'https://readdy.ai/api/search-image?query=Colombian%20arepa%20rellena%20grilled%20corn%20stuffed%20shredded%20beef%20chicken%20hogao%20sauce%20melted%20cheese%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20traditional%20authentic&width=500&height=600&seq=lf2&orientation=portrait',
        alt: 'Arepa rellena stuffed with beef and cheese',
        span: 'tall',
      },
      {
        id: 303,
        src: 'https://readdy.ai/api/search-image?query=Colombian%20patacon%20mixto%20twice%20fried%20green%20plantain%20loaded%20shredded%20beef%20chicken%20hogao%20avocado%20white%20cheese%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20Latin%20food&width=500&height=500&seq=lf3&orientation=squarish',
        alt: 'Patacón Mixto loaded with toppings',
        span: 'normal',
      },
      {
        id: 304,
        src: 'https://readdy.ai/api/search-image?query=Colombian%20desgranado%20street%20corn%20off%20cob%20butter%20cheese%20mayo%20lime%20chili%20powder%20colorful%20bowl%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20Latin%20street%20food&width=500&height=500&seq=lf4&orientation=squarish',
        alt: 'Desgranado Colombian street corn',
        span: 'normal',
      },
      {
        id: 305,
        src: 'https://readdy.ai/api/search-image?query=Colombian%20picada%20platter%20grilled%20chorizo%20chicharron%20papa%20criolla%20morcilla%20arepas%20sharing%20feast%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20overhead%20shot%20Latin%20food%20premium&width=800&height=500&seq=lf5&orientation=landscape',
        alt: 'Picada Colombiana sharing platter',
        span: 'wide',
      },
      {
        id: 306,
        src: 'https://readdy.ai/api/search-image?query=Kids%20salchipapa%20meal%20sliced%20beef%20sausage%20crispy%20golden%20fries%20ketchup%20mayo%20Colombian%20classic%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20children%20meal&width=500&height=500&seq=lf6&orientation=squarish',
        alt: 'Kids Salchipapa Meal',
        span: 'normal',
      },
    ],
  },
  {
    id: 'truck',
    title: 'Food Truck Experience',
    subtitle: 'The energy, the vibe, and the culture behind Bucara Burger in Boise',
    labelKey: 'gallery_cat_truck',
    subtitleKey: 'gallery_cat_truck_sub',
    icon: 'ri-truck-line',
    images: [
      {
        id: 401,
        src: 'https://readdy.ai/api/search-image?query=Colombian%20food%20truck%20exterior%20night%20urban%20street%20scene%20bright%20orange%20neon%20lights%20dramatic%20moody%20atmosphere%20dark%20background%20glowing%20signage%20Latin%20American%20street%20food%20culture%20vibrant%20city%20energy%20cinematic%20wide%20shot%20Boise%20Idaho&width=800&height=550&seq=ft1&orientation=landscape',
        alt: 'Bucara Burger food truck at night Boise Idaho',
        span: 'wide',
      },
      {
        id: 402,
        src: 'https://readdy.ai/api/search-image?query=Food%20truck%20kitchen%20interior%20chef%20cooking%20burgers%20grill%20action%20shot%20flames%20sizzling%20meat%20dark%20moody%20photography%20professional%20dramatic%20orange%20lighting%20vibrant%20energy%20Latin%20food%20truck%20cooking%20process%20close%20up&width=500&height=600&seq=ft2&orientation=portrait',
        alt: 'Chef cooking burgers on the grill',
        span: 'tall',
      },
      {
        id: 403,
        src: 'https://readdy.ai/api/search-image?query=Happy%20customers%20eating%20Colombian%20food%20at%20food%20truck%20outdoor%20dining%20smiling%20people%20enjoying%20burgers%20hot%20dogs%20community%20event%20warm%20atmosphere%20Latin%20food%20culture%20vibrant%20colors%20Boise%20Idaho&width=500&height=500&seq=ft3&orientation=squarish',
        alt: 'Customers enjoying Bucara Burger',
        span: 'normal',
      },
      {
        id: 404,
        src: 'https://readdy.ai/api/search-image?query=Food%20truck%20service%20window%20close%20up%20chef%20handing%20order%20to%20customer%20Colombian%20food%20truck%20orange%20branding%20warm%20lighting%20urban%20street%20food%20scene%20authentic%20Latin%20American%20food%20truck%20experience&width=500&height=500&seq=ft4&orientation=squarish',
        alt: 'Food truck service window',
        span: 'normal',
      },
      {
        id: 405,
        src: 'https://readdy.ai/api/search-image?query=Colombian%20food%20truck%20daytime%20exterior%20bright%20orange%20branding%20logo%20signage%20urban%20parking%20lot%20Boise%20Idaho%20Latin%20American%20food%20truck%20culture%20vibrant%20colors%20professional%20photography%20wide%20shot&width=800&height=500&seq=ft5&orientation=landscape',
        alt: 'Bucara Burger food truck daytime exterior',
        span: 'wide',
      },
      {
        id: 406,
        src: 'https://readdy.ai/api/search-image?query=Food%20truck%20grill%20close%20up%20sizzling%20beef%20patties%20cooking%20flames%20smoke%20dramatic%20dark%20moody%20photography%20professional%20orange%20lighting%20action%20shot%20Latin%20food%20truck%20kitchen%20process&width=500&height=500&seq=ft6&orientation=squarish',
        alt: 'Sizzling burgers on the grill',
        span: 'normal',
      },
    ],
  },
  {
    id: 'atmosphere',
    title: 'Brand Moments & Atmosphere',
    subtitle: 'The soul, identity, and Colombian spirit that makes Bucara Burger unique',
    labelKey: 'gallery_cat_atmosphere',
    subtitleKey: 'gallery_cat_atmosphere_sub',
    icon: 'ri-heart-line',
    images: [
      {
        id: 501,
        src: 'https://readdy.ai/api/search-image?query=Colombian%20food%20spread%20overhead%20flat%20lay%20burgers%20hot%20dogs%20empanadas%20arepas%20drinks%20colorful%20feast%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20overhead%20shot%20Colombian%20cuisine%20Boise%20Idaho&width=800&height=550&seq=bm1&orientation=landscape',
        alt: 'Full Colombian food spread overhead',
        span: 'wide',
      },
      {
        id: 502,
        src: 'https://readdy.ai/api/search-image?query=Limonada%20de%20coco%20Colombian%20coconut%20lemonade%20refreshing%20tropical%20drink%20glass%20straw%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20beverage%20vibrant%20colors&width=500&height=600&seq=bm2&orientation=portrait',
        alt: 'Limonada de coco refreshing drink',
        span: 'tall',
      },
      {
        id: 503,
        src: 'https://readdy.ai/api/search-image?query=Colombian%20natural%20fruit%20juices%20maracuya%20mora%20guanabana%20colorful%20tropical%20drinks%20glasses%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20beverages%20vibrant%20colors&width=500&height=500&seq=bm3&orientation=squarish',
        alt: 'Colombian natural fruit juices',
        span: 'normal',
      },
      {
        id: 504,
        src: 'https://readdy.ai/api/search-image?query=Colombian%20food%20truck%20branding%20orange%20black%20logo%20signage%20close%20up%20detail%20shot%20urban%20street%20food%20culture%20Latin%20American%20identity%20bold%20typography%20dark%20moody%20photography%20professional%20dramatic%20lighting&width=500&height=500&seq=bm4&orientation=squarish',
        alt: 'Bucara Burger branding and identity',
        span: 'normal',
      },
      {
        id: 505,
        src: 'https://readdy.ai/api/search-image?query=Colombian%20food%20truck%20community%20event%20outdoor%20gathering%20people%20enjoying%20Latin%20food%20Boise%20Idaho%20warm%20atmosphere%20vibrant%20energy%20street%20food%20festival%20urban%20culture%20authentic%20Colombian%20experience&width=800&height=500&seq=bm5&orientation=landscape',
        alt: 'Bucara Burger community event Boise',
        span: 'wide',
      },
      {
        id: 506,
        src: 'https://readdy.ai/api/search-image?query=Colombian%20flag%20colors%20food%20presentation%20patriotic%20plating%20red%20yellow%20blue%20accent%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20Colombian%20identity%20pride&width=500&height=500&seq=bm6&orientation=squarish',
        alt: 'Colombian identity and pride in every dish',
        span: 'normal',
      },
      {
        id: 507,
        src: 'https://readdy.ai/api/search-image?query=Gourmet%20burger%20and%20Colombian%20hot%20dog%20side%20by%20side%20comparison%20dark%20moody%20food%20photography%20professional%20black%20background%20dramatic%20orange%20lighting%20appetizing%20close%20up%20premium%20quality%20Latin%20food%20truck%20Boise%20Idaho&width=800&height=500&seq=bm7&orientation=landscape',
        alt: 'Burger and hot dog side by side',
        span: 'wide',
      },
    ],
  },
];
